<div class="booble-backdrop">
  <div class="xp-modal xp-modal-cadastro">
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="d-flex flex-row-reverse w-100">
            <div (click)="closeModal()" class="close-icon tappable">
              <img src="assets/image/close-modal-icon.svg" />
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="modal-dialog-scrollable-general">
            <div class="main">
              <mat-icon
                class="mb-4"
                style="transform: scale(2.5)"
                svgIcon="success"
              ></mat-icon>
              <p class="message mb-4 mt-3">Câmbio fechado com sucesso.</p>
              <p class="description-inbound mb-4">
                Daremos sequência no recebimento do dinheiro em reais na conta
                cadastrada em até 1 dia útil.
              </p>
              <button
                (click)="closeModal()"
                type="button"
                class="btn btn-block mt-4 w-25"
                [ngClass]="
          companyId ? 'btn-dark-primary-blue' : 'btn-dark-primary-blue-pf'
        "
                type="button"
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
